module.exports = __webpack_public_path__ + "img/blueHirPro.7c8b5f97.svg";